





































import { routeInfos } from "@/router/routes";
import { Component, Vue } from "vue-property-decorator";
import LoginFormBoxComponent from "@/components/common/form/LoginFormBoxComponent.vue";
import InputComponent from "@/components/common/form/InputComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";

@Component({
  components: {
    LoginFormBoxComponent,
    InputComponent,
    FooterComponent
  }
})
export default class PasswordsIssuePage extends Vue {
  routeInfos = routeInfos;
}
